import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const BaggageStorageIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "BaggageStorageIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M18.8139 21.2169H18.3062C16.7329 21.2169 15.3368 20.279 14.725 18.8734H11.3272C10.2876 18.8734 9.2668 18.4527 8.52652 17.719C8.20737 17.4027 8.03165 16.9804 8.03165 16.5299C8.03165 16.0795 8.20737 15.6572 8.52648 15.3409C9.26679 14.6072 10.2876 14.1864 11.3272 14.1864H14.725C15.3368 12.7809 16.7329 11.8429 18.3062 11.8429H18.8139C20.9676 11.8429 22.7198 13.5951 22.7198 15.7488V17.3111C22.7198 19.4648 20.9676 21.2169 18.8139 21.2169ZM11.3272 15.7488C10.6963 15.7488 10.0763 16.0046 9.62625 16.4506C9.59957 16.4771 9.59399 16.5084 9.59399 16.53C9.59399 16.5516 9.59961 16.5828 9.62629 16.6093C10.0763 17.0553 10.6963 17.3111 11.3272 17.3111H15.2799C15.6364 17.3111 15.9476 17.5524 16.0365 17.8976C16.3027 18.9321 17.2361 19.6546 18.3061 19.6546H18.8139C20.1061 19.6546 21.1574 18.6033 21.1574 17.3111V15.7488C21.1574 14.4566 20.1061 13.4053 18.8139 13.4053H18.3061C17.2361 13.4053 16.3027 14.1278 16.0365 15.1623C15.9476 15.5075 15.6364 15.7488 15.2799 15.7488L11.3272 15.7488ZM14.3982 21.2169C14.3982 20.7855 14.0484 20.4358 13.617 20.4358H7.40672C5.68378 20.4358 4.28205 19.0341 4.28205 17.3111V11.882C4.28205 10.1591 5.68377 8.75732 7.40672 8.75732H18.0306C19.2417 8.75732 20.3544 9.46721 20.8655 10.5658C21.0475 10.957 21.5122 11.1266 21.9033 10.9446C22.2945 10.7626 22.464 10.2979 22.2821 9.90677C21.5157 8.25941 19.8469 7.19499 18.0306 7.19499H7.40673C4.82232 7.19499 2.71973 9.29758 2.71973 11.882V17.3111C2.71973 19.8955 4.82232 21.9981 7.40673 21.9981H13.617C14.0484 21.9981 14.3982 21.6484 14.3982 21.2169Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M15.2574 6.10137C14.826 6.10137 14.4763 5.75164 14.4763 5.3202C14.4763 4.35105 13.6878 3.56258 12.7187 3.56258C11.7495 3.56258 10.961 4.35105 10.961 5.3202C10.961 5.75164 10.6113 6.10137 10.1799 6.10137C9.74843 6.10137 9.3987 5.75164 9.3987 5.3202C9.3987 3.48958 10.888 2.00024 12.7187 2.00024C14.5493 2.00024 16.0386 3.48957 16.0386 5.3202C16.0386 5.75164 15.6889 6.10137 15.2574 6.10137ZM19.0092 15.5535C18.4699 15.5535 18.0327 15.9907 18.0327 16.5299C18.0327 17.0692 18.4699 17.5064 19.0092 17.5064C19.5485 17.5064 19.9857 17.0692 19.9857 16.5299C19.9857 15.9907 19.5485 15.5535 19.0092 15.5535Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default BaggageStorageIcon;
